import { IS_ZONA_JOBS } from '.'
import avatarDefaultBM from '../assets/images/sin-imagen.png'
import avatarDefaultZJ from '../assets/images/sin-imagen-zj.png'

const avatarDefault = IS_ZONA_JOBS ? avatarDefaultZJ : avatarDefaultBM

export default avatarDefault
